import type { StorageAPISynchronous } from './common'

export default function getLocalStorage(key: string): StorageAPISynchronous {
  return {
    get() {
      return localStorage.getItem(key) ?? undefined
    },
    set(value: string) {
      localStorage.setItem(key, value)
    },
    del() {
      localStorage.removeItem(key)
    },
  }
}
